import React from 'react';
import PropTypes from 'prop-types';

const QuestionCard = ({ question, selectedOption, isMarked, onAnswerSelect, onMarkForReview }) => {
  return (
    <div className="card p-6">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <h2 className="text-lg font-medium text-gray-900 leading-relaxed" dangerouslySetInnerHTML={{ __html: question.en.value }} />
        </div>
        <button
          onClick={onMarkForReview}
          className={`ml-4 px-3 py-1 text-sm rounded-md border ${
            isMarked ? 'bg-yellow-100 border-yellow-300 text-yellow-800' : 'bg-gray-100 border-gray-300 text-gray-600'
          }`}
        >
          {isMarked ? 'Marked' : 'Mark for Review'}
        </button>
      </div>

      <div className="space-y-3">
        {question.en.options.map((option, index) => (
          <label
            key={index}
            className={`flex items-start space-x-3 p-3 rounded-lg border cursor-pointer ${
              selectedOption === option.prompt ? 'bg-blue-50 border-blue-300' : 'bg-white border-gray-200 hover:border-gray-300'
            }`}
          >
            <input
              type="radio"
              name={`question-${question._id}`}
              checked={selectedOption === option.prompt}
              onChange={() => {
                console.log('Radio button clicked:', { 
                  index, 
                  prompt: option.prompt, 
                  questionId: question._id, 
                  selectedOption 
                });
                onAnswerSelect(option.prompt);
              }}
              className="mt-1 w-4 h-4 text-blue-600 focus:ring-blue-500 border-gray-300"
            />
            <span className="flex-1 text-gray-900">
              {String.fromCharCode(65 + index)}. {option.value}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

QuestionCard.propTypes = {
  question: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    en: PropTypes.shape({
      value: PropTypes.string.isRequired,
      options: PropTypes.arrayOf(PropTypes.shape({
        prompt: PropTypes.number.isRequired,
        value: PropTypes.string.isRequired
      })).isRequired
    }).isRequired,
    sectionName: PropTypes.string,
    questionNumber: PropTypes.number
  }).isRequired,
  selectedOption: PropTypes.number,
  isMarked: PropTypes.bool.isRequired,
  onAnswerSelect: PropTypes.func.isRequired,
  onMarkForReview: PropTypes.func.isRequired,
};

export default QuestionCard; 